import React from 'react';
import { Box, Skeleton } from '@mui/material';

const TotalCostSkeleton = () => {
  // Create 4 skeleton info cards to match ORDER_DETAILS_CONTACT_STATS array length
  const skeletonInfoCards = Array.from({ length: 4 }, (_, index) => (
    <Box key={index} className="card">
      {/* Icon skeleton */}
      <Skeleton 
        variant="rectangular" 
        width={40} 
        height={40} 
        sx={{ borderRadius: '6px' }}
      />
      
      {/* Meta info box skeleton */}
      <Box className="meta_info_box">
        {/* Title skeleton */}
        <Skeleton 
          variant="text" 
          width={100} 
          height={20}
        />
        
        {/* Value skeleton */}
        <Skeleton 
          variant="text" 
          width={100}     
          height={25}
        />
      </Box>
    </Box>
  ));

  return (
    <Box className="total_cost">
      {/* Main total card skeleton */}
      <Box className="total_card">
        {/* Title skeleton */}
        <Skeleton 
          variant="rectangular" 
          width={40} 
          height={40}
          sx={{ borderRadius: '6px' }}
        />
        
        {/* Amount skeleton */}
        <Skeleton 
          variant="text" 
          width={100} 
          height={22}
        />
        
        {/* Info text skeleton - multiple lines to simulate the breakdown */}
        <Skeleton 
          variant="text" 
          width={100} 
          height={16}
        />
      </Box>
      
      {/* Info cards skeleton */}
      {skeletonInfoCards}
    </Box>
  );
};

export default TotalCostSkeleton; 